import ErrorIcon from '@mui/icons-material/Error'
import { Box, Card, CardActionArea, Stack, Typography } from '@mui/material'
import CampaignImage from '~/components/CampaignImage'
import { MultilineTypography } from '~/components/common/MultilineTypography'
import { CampaignStatus, ImageUrl } from '~/generated/graphql'
import NextLink from 'next/link'
import { FC } from 'react'
import { pagesPath } from '~/lib/$path'
import { decodeId } from '~/lib/convertId'
import { isRevisionRequired } from '~/lib/CampaignStatus'

type Props = {
  campaign: {
    id: string
    name: string
    status: CampaignStatus
    coverImageUrls: readonly ImageUrl[]
  }
}

export const WaitingCampaignCell: FC<Props> = ({ campaign }) => {
  const isRevisionRequiredStatus = isRevisionRequired(campaign.status)
  const coverImageUrls = campaign.coverImageUrls[0]

  const campaignId = decodeId(campaign.id).id
  return (
    <Card
      elevation={0}
      sx={{
        minWidth: '128px',
        width: '128px',
        height: '180px',
        overflow: 'hidden',
      }}
    >
      <NextLink href={pagesPath.campaigns._campaignId(campaignId).$url()} passHref legacyBehavior>
        <CardActionArea>
          <Stack gap={1}>
            {/* キャンペーン名 */}
            <MultilineTypography variant="caption" maxLines={1} align="left">
              <Typography sx={{ fontWeight: 'bold' }}>{campaign.name}</Typography>
            </MultilineTypography>
            <Box position="relative">
              {/* キャンペーン画像 */}
              <CampaignImage
                image={{
                  url: coverImageUrls?.original ?? '',
                  w480xh480: coverImageUrls && { url: coverImageUrls.medium },
                  w120xh120: coverImageUrls && { url: coverImageUrls.small },
                }}
                imageSize="small"
                variant={isRevisionRequiredStatus ? 'error' : 'primary'}
              />
              {isRevisionRequiredStatus && (
                <Box position="absolute" top={2} bottom={2} left={2} right={2}>
                  {/* グレーアウト & 「修正が必要です」を中央寄せするためののBox */}
                  <Box
                    bgcolor="#00000064"
                    width="100%"
                    height="100%"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    {/* 赤の背景色をつけるためのBox */}
                    <Box
                      sx={{
                        backgroundColor: 'error.main',
                        borderRadius: 4,
                        py: 0.5,
                        px: 1,
                      }}
                    >
                      <Typography
                        variant="caption"
                        style={{
                          color: '#ffffff',
                          fontWeight: 'bold',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: 4,
                          flexWrap: 'nowrap',
                        }}
                      >
                        <ErrorIcon sx={{ fontSize: 'inherit' }} />
                        修正が必要です
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          </Stack>
        </CardActionArea>
      </NextLink>
    </Card>
  )
}
